<template>
  <div
    class="comp-bench-select"
    :style="cusStyle"
  >
    <el-select
      v-model="defaultValue"
      popper-class="bench-select-dropdown"
      :style="cusStyle"
      :clearable="clearable"
      :placeholder="placeholder"
      :filterable="filterable"
      :multiple="multiple"
      :multiple-limit="multipleLimit"
      @visible-change="visibleChange"
      @change="change"
      @clear.once="clear"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
        <slot :item="item"></slot>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'BenchSelect',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    width: {
      type: String,
      default: '200px'
    },
    clearable: {
      type: Boolean,
      defautl: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    multipleLimit: {
      type: Number,
      default: 1
    },
    filterable: {
      type: Boolean,
      defautl: false
    },
    options: {
      type: Array,
      default: () => [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        },
        {
          value: '选项3',
          label: '蚵仔煎'
        },
        {
          value: '选项4',
          label: '龙须面'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ]
    }
  },
  data() {
    return {
      defaultValue: this.value
    };
  },
  computed: {
    cusStyle() {
      return {
        width: `${this.width}!important`
      };
    }
  },
  watch: {
    value(nv) {
      this.defaultValue = nv;
    }
  },
  mounted() {},
  methods: {
    change(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
    clear(value) {
      this.$emit('clear', value);
    },
    visibleChange() {
      let dropdownEl = document.querySelector('.bench-select-dropdown');
      if (dropdownEl) {
        dropdownEl.style.width = this.width;
      }
    }
  }
};
</script>

<style lang="scss">
.comp-bench-select {
  display: inline-block;
  .el-input__suffix {
    right: 26px;
    font-size: 16px;
    color: #666;
    cursor: pointer;
  }
  .el-input__suffix-inner {
    display: inline-block;
    height: 100%;
  }
  .el-select__caret {
    display: flex;
    align-items: center;
  }
  .el-input__inner {
    color: #333;
    padding: 0 41px 0 28px;
    border: 1px solid #d5d5d5;
    background-color: #fff;
  }
  .el-input.is-focus .el-input__inner {
    border-color: #666;
  }
  .el-input__inner:focus {
    border-color: #666;
  }
  .el-input__inner:hover {
    border-color: #666;
  }
  .el-input__inner,
  .el-input.is-focus .el-input__inner,
  .el-input__suffix .el-input__inner {
    border-radius: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-select .el-input .el-select__caret {
    width: unset;
  }
}
.bench-select-dropdown {
  .popper__arrow {
    display: none;
  }

  .el-select-dropdown__list {
    box-shadow: 0px 2px 9px 0px rgba(56, 58, 66, 0.2);
    border-radius: 4px;
  }
  .el-select-dropdown__item {
    color: #333;
    &:hover {
      background-color: #f6f7f9;
    }
  }
}
</style>

<style scoped lang="scss">
/* @import url(); 引入css类 */
</style>
